import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from "./../services/http";
import { Breadcrumb, Layout, Row, Col, Card, Form, Select, message, Button, Modal, Input, Divider, Upload } from 'antd';
const { Content } = Layout;

function SettingsAuthForm () {

    const [form] = Form.useForm();
    const [settingsAuthForm] = Form.useForm();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        GetAuthConfig();
    }, []);

    const GetAuthConfig = async () => {
        try {
            const response = await axios.HTTP_GET('/api/v1/auth/personal-emails');
            if (response && response.length > 0) {
                form.setFieldsValue({ emailn1: response[0].email_n1 });
                form.setFieldsValue({ emailn2: response[0].email_n2 });
            }
        } catch (e) {
            console.error('Error al cargar la config:', e);
        }
    }

    const handleSubmit = async (values) => {
        setLoading(true);
        const response = await axios.HTTP_POST('/api/v1/auth/personal-email/save', values);
        if (response) {
            message.success(response.data.message);
            Navigate("/home");
        }
    }

    const Navigate = (path) => {
        navigate(path);
    }

    return (
        <>
            <Layout>
                <Content
                    className='primary-container'>
                        <Breadcrumb 
                            className='breadcrumb' 
                            items={[
                                { title: <a href="/home">Inicio</a> },
                                { title: "Configuración de Autorización" }
                            ]} 
                        />
                        <div
                            className='container-content'
                            >
                            <Row gutter={[8, 8]} justify="center">
                                <Col xs={{ flex: '100%' }} md={{ flex: '60%' }} xl={{ flex: '40%' }}>
                                    <Card title={"Correos para autorizar (Control de Pagos)"}>
                                        <Form
                                            layout="vertical"
                                            form={form}
                                            onFinish={handleSubmit}
                                        >
                                            <Form.Item
                                                label="Correo electrónico (N1)"
                                                name="emailn1"
                                                rules={[{ required: true, message: 'Por favor ingresar el correo electrónico de N1' }]}
                                            >
                                                <Input />
                                            </Form.Item>
                                            <Form.Item
                                                label="Correo electrónico (N2)"
                                                name="emailn2"
                                                rules={[{ required: true, message: 'Por favor ingresar el correo electrónico de N2' }]}
                                            >
                                                <Input />
                                            </Form.Item>
                                            <Divider style={{ margin: '24px 0' }} />
                                            <Form.Item>
                                                <div style={{ display: 'flex', justifyContent: 'end', gap: '10px' }}>
                                                    <Button type="default" onClick={() => Navigate("/home")}>
                                                        Cancelar
                                                    </Button>
                                                    <Button type="primary" loading={loading} htmlType="submit">
                                                        Guardar
                                                    </Button>
                                                </div>
                                            </Form.Item>
                                        </Form>
                                    </Card>
                                </Col>
                            </Row>
                        </div>
                </Content>
            </Layout>
        </>
    )
}

export default SettingsAuthForm;